<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]="windowHash"></sub-header>
<p-scrollPanel [style]="{height: '80vh'}" styleClass="custombar1">
  <div [ngClass]="{'container container-fluid' : !askUser, 'container container-fluid mt-4': askUser}">
    <div class="row" *ngIf="isSingLoad()">
      <div class="col-12 justify-content-center m-t-md">
        <div *ngIf="additionalMsg; else elseBlockNonAditionalMsg" class="col-12" [innerHTML]="additionalMsg"></div>
      </div>
      <dl class="dl-horizontal col-xs-12 col-sm-6">
        <dt>{{ 'ValidateSignDocument.signer' | translate }}</dt>
        <dd class="m-b-sm">{{signature.signer}}</dd>
        <dt>{{ 'ValidateSignDocument.date' | translate }}</dt>
        <dd class="m-b-sm">{{signature.date | date:'dd/MM/yyyy HH:mm:ss'}}</dd>
        <dt>{{ 'ValidateSignDocument.fichero' | translate }}</dt>
        <dd class="m-b-sm">{{file.name}}</dd>
        <dt>{{ 'ValidateSignDocument.format.sign' | translate }}</dt>
        <dd class="m-b-sm">
          {{signature.signatureFormat.type}} -
          {{signature.signatureFormat.mode}}
        </dd>
      </dl>
      <dl class="dl-horizontal col-xs-12 col-sm-6" *ngIf="signature.comment">
        <dt>{{ 'ValidateSignDocument.comment' | translate }}</dt>
        <dd class="m-b-sm text-break">{{signature.comment}}</dd>
      </dl>
      <dl class="dl-horizontal col-xs-12 col-sm-6"
        *ngIf="validationResultSignature === SignatureValidationCode.ERROR_CERTIFICATE_REVOKED">
        <!-- Resutado = 5 -->
        <dt>{{ 'ValidateSignDocument.validate' | translate }}</dt>
        <dd class="m-b-sm text-warning">
          {{ 'ValidateSignDocument.result.validate.ERROR_CERTIFICATE_REVOKED' |
          translate }}
        </dd>
        <dt>{{ 'ValidateSignDocument.integrity' | translate }}</dt>
        <dd class="m-b-sm">
          {{ 'ValidateSignDocument.result.integrity.ok' | translate }}
        </dd>
        <dt>{{ 'ValidateSignDocument.state.certificate' | translate }}</dt>
        <dd class="m-b-sm text-warning">
          {{
          'ValidateSignDocument.result.state.certificate.ERROR_CERTIFICATE_REVOKED'
          | translate }}
        </dd>
      </dl>
      <dl class="dl-horizontal col-xs-12 col-sm-6"
        *ngIf="validationResultSignature === SignatureValidationCode.ERROR_CERTIFICATE_EXPIRED">
        <!-- Resutado = 5 -->
        <dt>{{ 'ValidateSignDocument.validate' | translate }}</dt>
        <dd class="m-b-sm text-warning">
          {{ 'ValidateSignDocument.result.validate.ERROR_CERTIFICATE_EXPIRED' |
          translate }}
        </dd>
        <dt>{{ 'ValidateSignDocument.integrity' | translate }}</dt>
        <dd class="m-b-sm">
          {{ 'ValidateSignDocument.result.integrity.ok' | translate }}
        </dd>
        <dt>{{ 'ValidateSignDocument.state.certificate' | translate }}</dt>
        <dd class="m-b-sm text-warning">
          {{
          'ValidateSignDocument.result.state.certificate.ERROR_CERTIFICATE_EXPIRED'
          | translate }}
        </dd>
      </dl>
      <dl class="dl-horizontal col-xs-12 col-sm-6"
        *ngIf="validationResultSignature === SignatureValidationCode.ERROR_INTEGRITY">
        <!-- Resutado = 2 -->
        <dt>{{ 'ValidateSignDocument.validate' | translate }}</dt>
        <dd class="m-b-sm text-danger">
          {{ 'ValidateSignDocument.result.validate.ERROR_INTEGRITY' | translate
          }}
        </dd>
        <dt>{{ 'ValidateSignDocument.integrity' | translate }}</dt>
        <dd class="m-b-sm text-danger">
          {{ 'ValidateSignDocument.result.integrity.2' | translate }}
        </dd>
        <dt>{{ 'ValidateSignDocument.state.certificate' | translate }}</dt>
        <dd class="m-b-sm text-warning">
          {{ 'ValidateSignDocument.result.state.certificate.2' | translate }}
        </dd>
      </dl>
      <dl class="dl-horizontal col-xs-12 col-sm-6"
        *ngIf="validationResultSignature === SignatureValidationCode.ERROR_SIGNATURE">
        <!-- Resutado = 3 -->
        <dt>{{ 'ValidateSignDocument.validate' | translate }}</dt>
        <dd class="m-b-sm text-danger">
          {{ 'ValidateSignDocument.result.validate.ERROR_SIGNATURE' | translate
          }}
        </dd>
        <dt>{{ 'ValidateSignDocument.integrity' | translate }}</dt>
        <dd class="m-b-sm text-danger">
          {{ 'ValidateSignDocument.result.integrity.3' | translate }}
        </dd>
        <dt>{{ 'ValidateSignDocument.state.certificate' | translate }}</dt>
        <dd class="m-b-sm text-danger">
          {{ 'ValidateSignDocument.result.state.certificate.3' | translate }}
        </dd>
      </dl>
      <dl class="dl-horizontal col-xs-12 col-sm-6"
        *ngIf="validationResultSignature === SignatureValidationCode.ERROR_CERTIFICATE">
        <!-- Resutado = 4 -->
        <dt>{{ 'ValidateSignDocument.validate' | translate }}</dt>
        <dd class="m-b-sm text-danger">
          {{ 'ValidateSignDocument.result.validate.ERROR_CERTIFICATE' |
          translate }}
        </dd>
        <dt>{{ 'ValidateSignDocument.integrity' | translate }}</dt>
        <dd class="m-b-sm">
          {{ 'ValidateSignDocument.result.integrity.ok' | translate }}
        </dd>
        <dt>{{ 'ValidateSignDocument.state.certificate' | translate }}</dt>
        <dd class="m-b-sm text-warning">
          {{ 'ValidateSignDocument.result.state.certificate.ERROR_CERTIFICATE' |
          translate }}
        </dd>
      </dl>
      <dl class="dl-horizontal col-xs-12 col-sm-6" *ngIf="validationResultSignature === SignatureValidationCode.OK">
        <!-- Resutado = 1 -->
        <dt>{{ 'ValidateSignDocument.validate' | translate }}</dt>
        <dd class="m-b-sm text-info">
          {{ 'ValidateSignDocument.result.validate.OK' | translate }}
        </dd>
        <dt>{{ 'ValidateSignDocument.integrity' | translate }}</dt>
        <dd class="m-b-sm">
          {{ 'ValidateSignDocument.result.integrity.ok' | translate }}
        </dd>
        <dt>{{ 'ValidateSignDocument.state.certificate' | translate }}</dt>
        <dd class="m-b-sm text-warning" *ngIf="!signature.verification.certificate.ok">
          <b>{{
            'ValidateSignDocument.result.state.certificate.WARNING_CERTIFICATE'
            | translate }}</b>
          <span *ngIf="certificateMessages && certificateMessages.length > 0">
            ({{signature.verification.certificate.validationMessages}})</span>
        </dd>
        <dd class="m-b-sm">{{signature.verification.certificateMessage}}</dd>
      </dl>
    </div>
  </div>
</p-scrollPanel>
<ng-template #elseBlockNonAditionalMsg>
  <div class="col-12 alert alert-success text-center" *ngIf="validationResultSignature === SignatureValidationCode.OK">
    {{'ValidateSignDocument.signature.ok' | translate}}
  </div>
  <div class="col-12 alert alert-danger text-center" *ngIf="validationResultSignature !== SignatureValidationCode.OK">
    {{'ValidateSignDocument.signature.err' | translate}}
  </div>
</ng-template>